/* =====================================================================
   Soul of Papers — product landing interactivity (vanilla, no deps)
   - gallery view switching
   - quantity stepper (wired to the product form quantity input)
   - WebAudio "signature song" preview synth (play/pause/progress/waveform)
   - dancing paper cast toggle while the song plays
   - video review carousel
   - estimated delivery date range
   Re-inits on Shopify theme-editor section load.
   ===================================================================== */
(function () {
  'use strict';

  /* ---------- HERO ---------- */
  function initHero(root) {
    if (!root || root.dataset.sopInit === '1') return;
    root.dataset.sopInit = '1';

    var stage = root.querySelector('[data-sop-stage]');
    var views = Array.prototype.slice.call(root.querySelectorAll('[data-sop-view]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sop-thumb]'));

    // gallery view switching
    function show(idx) {
      views.forEach(function (v) { v.hidden = String(v.dataset.sopView) !== String(idx); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.sopThumb) === String(idx)); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.sopThumb); });
    });
    if (thumbs.length) show(thumbs[0].dataset.sopThumb);

    // quantity stepper
    var qtyInput = root.querySelector('[data-sop-qty-input]');
    root.querySelectorAll('[data-sop-qty-dec]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v; qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    root.querySelectorAll('[data-sop-qty-inc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1);
        qtyInput.value = v; qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // estimated delivery dates
    var from = root.querySelector('[data-sop-deliver-from]');
    var to = root.querySelector('[data-sop-deliver-to]');
    if (from || to) {
      var minD = parseInt(root.dataset.sopDeliverMin, 10) || 5;
      var maxD = parseInt(root.dataset.sopDeliverMax, 10) || 9;
      if (from) from.textContent = fmtDate(minD);
      if (to) to.textContent = fmtDate(maxD);
    }

    // waveform bars (build once)
    var waveWrap = root.querySelector('[data-sop-wave]');
    if (waveWrap && !waveWrap.childElementCount) {
      for (var i = 0; i < 40; i++) {
        var h = 6 + Math.round(20 * Math.abs(Math.sin(i * 0.7) + 0.35 * Math.sin(i * 1.9)));
        h = Math.min(26, Math.max(6, h));
        var s = document.createElement('span');
        s.className = 'wv';
        s.style.height = h + 'px';
        s.style.animationDuration = (0.5 + (i % 5) * 0.08).toFixed(2) + 's';
        s.style.animationDelay = (i * 0.035).toFixed(2) + 's';
        waveWrap.appendChild(s);
      }
    }

    // song preview synth
    setupSynth(root, stage);
  }

  function fmtDate(offset) {
    var d = new Date(); d.setDate(d.getDate() + offset);
    var day = d.getDate();
    var v = day % 100;
    var suf = (['th', 'st', 'nd', 'rd'][(v - 20) % 10] || ['th', 'st', 'nd', 'rd'][v] || 'th');
    var wd = d.toLocaleDateString('en-US', { weekday: 'long' });
    var mo = d.toLocaleDateString('en-US', { month: 'long' });
    return wd + ', ' + mo + ' ' + day + suf;
  }

  function setupSynth(root, stage) {
    var btn = root.querySelector('[data-sop-play]');
    if (!btn) return;
    var iconPlay = root.querySelector('[data-sop-icon-play]');
    var iconPause = root.querySelector('[data-sop-icon-pause]');
    var progEl = root.querySelector('[data-sop-progress]');
    var timeEl = root.querySelector('[data-sop-time]');

    var root_hz = parseFloat(root.dataset.sopRoot) || 261.63;
    var tempo = parseFloat(root.dataset.sopTempo) || 132;
    var pattern = (root.dataset.sopPattern || '0,4,7,9,7,4,7,9,4,7,9,7')
      .split(',').map(function (n) { return parseInt(n, 10) || 0; });

    var ctx = null, master = null, step = 0, interval = null, raf = null, playStart = 0, playing = false;
    var SPAN = 30000; // 30s loop

    function ensureCtx() {
      if (!ctx) {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return false;
        ctx = new AC();
        master = ctx.createGain();
        master.gain.value = 0.0001;
        master.connect(ctx.destination);
      }
      if (ctx.state === 'suspended') ctx.resume();
      return true;
    }
    function voice(freq, t, dur, type, vol) {
      var o = ctx.createOscillator(); o.type = type; o.frequency.value = freq;
      var g = ctx.createGain();
      g.gain.setValueAtTime(0.0001, t);
      g.gain.linearRampToValueAtTime(vol, t + 0.015);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g); g.connect(master); o.start(t); o.stop(t + dur + 0.05);
    }
    function tick() {
      var t = ctx.currentTime + 0.02;
      var scale = [0, 2, 4, 7, 9];
      var deg = pattern[step % pattern.length];
      var semis = scale[deg % 5] + 12 * Math.floor(deg / 5);
      voice(root_hz * Math.pow(2, semis / 12), t, 0.55, 'triangle', 0.22);
      if (step % 2 === 0) voice(root_hz * Math.pow(2, (semis + 7) / 12) / 2, t, 0.5, 'sine', 0.10);
      if (step % 4 === 0) voice(root_hz / 2, t, 0.9, 'sine', 0.16);
      step++;
    }
    function loop() {
      if (!playing) return;
      var t = (performance.now() - playStart) % SPAN;
      if (progEl) progEl.style.width = (t / SPAN) * 100 + '%';
      if (timeEl) timeEl.textContent = '0:' + String(Math.floor(t / 1000)).padStart(2, '0');
      raf = requestAnimationFrame(loop);
    }
    function clearTimers() {
      if (interval) { clearInterval(interval); interval = null; }
      if (raf) { cancelAnimationFrame(raf); raf = null; }
    }
    function setPlaying(on) {
      playing = on;
      if (iconPlay) iconPlay.hidden = on;
      if (iconPause) iconPause.hidden = !on;
      btn.setAttribute('aria-label', on ? 'Pause preview' : 'Play preview');
      if (stage) stage.classList.toggle('sop-dance', on);
    }
    function play() {
      if (!ensureCtx()) return;
      clearTimers();
      var now = ctx.currentTime;
      master.gain.cancelScheduledValues(now);
      master.gain.setValueAtTime(Math.max(0.0001, master.gain.value), now);
      master.gain.linearRampToValueAtTime(0.85, now + 0.08);
      step = 0; tick();
      interval = setInterval(tick, 60000 / tempo / 2);
      playStart = performance.now();
      raf = requestAnimationFrame(loop);
      setPlaying(true);
    }
    function pause() {
      clearTimers();
      if (ctx && master) {
        var now = ctx.currentTime;
        master.gain.cancelScheduledValues(now);
        master.gain.setValueAtTime(master.gain.value, now);
        master.gain.linearRampToValueAtTime(0.0001, now + 0.12);
      }
      setPlaying(false);
    }
    btn.addEventListener('click', function () { playing ? pause() : play(); });
    root._sopStopSynth = pause;
  }

  /* ---------- REVIEWS video carousel ---------- */
  function initReviews(root) {
    if (!root || root.dataset.sopInit === '1') return;
    root.dataset.sopInit = '1';
    var track = root.querySelector('[data-sop-vidtrack]');
    if (!track) return;
    var prev = root.querySelector('[data-sop-vid-prev]');
    var next = root.querySelector('[data-sop-vid-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -512, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: 512, behavior: 'smooth' }); });
    // click a poster to play its inline video
    root.querySelectorAll('[data-sop-vidcard]').forEach(function (card) {
      var overlay = card.querySelector('[data-sop-vidoverlay]');
      if (overlay) overlay.style.cursor = 'pointer';
      card.addEventListener('click', function () {
        var v = card.querySelector('video');
        if (!v || card.dataset.sopPlaying === '1') return;
        card.dataset.sopPlaying = '1';
        var frame = card.querySelector('.frame') || card;
        // hide every overlay element (poster, play icon, gradient, badge, caption)
        // — done via inline display:none so it beats their inline display styles
        Array.prototype.forEach.call(frame.children, function (el) {
          if (el.tagName !== 'VIDEO') el.style.display = 'none';
        });
        v.hidden = false;
        v.removeAttribute('hidden');
        v.setAttribute('controls', '');
        v.style.display = 'block';
        var p = v.play();
        if (p && p.catch) { p.catch(function () {}); }
      });
    });
  }

  /* ---------- boot ---------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-sop-hero]').forEach(initHero);
    (scope || document).querySelectorAll('[data-sop-reviews]').forEach(initReviews);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  // Shopify theme editor: re-init the section that (re)loaded
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var h = e.target.querySelector('[data-sop-hero]');
    if (h && typeof h._sopStopSynth === 'function') h._sopStopSynth();
  });
})();
